// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ILinkedEmployeeInfoDto } from './ILinkedEmployeeInfoDto';
import {
    ILinkedEmployeeInfoDtoFromJSON,
    ILinkedEmployeeInfoDtoFromJSONTyped,
    ILinkedEmployeeInfoDtoToJSON,
    ILinkedEmployeeInfoDtoToJSONTyped,
} from './ILinkedEmployeeInfoDto';

/**
 * 
 * @export
 * @interface IEmployeeLinkResponseDto
 */
export interface IEmployeeLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IEmployeeLinkResponseDto
     */
    link_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IEmployeeLinkResponseDto
     */
    primary_employee_id?: number;
    /**
     * 
     * @type {Set<ILinkedEmployeeInfoDto>}
     * @memberof IEmployeeLinkResponseDto
     */
    linked_employees?: Set<ILinkedEmployeeInfoDto>;
}

/**
 * Check if a given object implements the IEmployeeLinkResponseDto interface.
 */
export function instanceOfIEmployeeLinkResponseDto(value: object): value is IEmployeeLinkResponseDto {
    return true;
}

export function IEmployeeLinkResponseDtoFromJSON(json: any): IEmployeeLinkResponseDto {
    return IEmployeeLinkResponseDtoFromJSONTyped(json, false);
}

export function IEmployeeLinkResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeLinkResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'link_id': json['link_id'] == null ? undefined : json['link_id'],
        'primary_employee_id': json['primary_employee_id'] == null ? undefined : json['primary_employee_id'],
        'linked_employees': json['linked_employees'] == null ? undefined : (new Set((json['linked_employees'] as Array<any>).map(ILinkedEmployeeInfoDtoFromJSON))),
    };
}

export function IEmployeeLinkResponseDtoToJSON(json: any): IEmployeeLinkResponseDto {
    return IEmployeeLinkResponseDtoToJSONTyped(json, false);
}

export function IEmployeeLinkResponseDtoToJSONTyped(value?: IEmployeeLinkResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'link_id': value['link_id'],
        'primary_employee_id': value['primary_employee_id'],
        'linked_employees': value['linked_employees'] == null ? undefined : (Array.from(value['linked_employees'] as Set<any>).map(ILinkedEmployeeInfoDtoToJSON)),
    };
}

